module.exports = __webpack_public_path__ + "img/zai@2x.0f4c3885.png";